import toast from 'react-hot-toast';
import { httpRequest } from 'src/services/httpRequest';

export const columns = [
  'Department ID',
    'Department Name',
    'Department Description',
    'Actions (Edit/Delete)'
];

interface Field {
  departmentId: number;
  departmentName: string;
  description: string;
  action: string;
}

interface DepartmentFields {
  DepartmentID: number;
  DepartmentName: string;
  Description: string;
  DepartmentImage: string;
}

// Fetch all departments
export const getData = async (
  url: string,
  setState: (data: Field[]) => void,
  action: (data: any) => void
) => {
  try {
    const response = await httpRequest('GET', url);
    if (response?.status === 'success') {
      const data = await response?.data?.Data;
      const Departments = data?.map((item: DepartmentFields) => {
        return {
            departmentId: item.DepartmentID,
          departmentName: item.DepartmentName,
          description: item.Description,
          action: action(item)
        };
      });
      setState(Departments);
    } else if (response.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
    }
  } catch (error) {
    toast.error('An error occurred while fetching departments');
    console.error('Error:', error);
  }
};
